<div
	class="gabby-channel-topic-label"
	title="Channel Type: {{ channel?.topic }}"
	[ngClass]="'gabby-channel-topic-label-' + getLabelType()"
>
	{{ getLabelType() }}
</div>
